import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import { controlStaffService } from '@/services/control/staff-service';
import type { StaffMembers } from '@/types/control/staff';

import { adminQueryKeys } from '@/hooks/admin/query-keys';
import { retryControlApi } from '@/hooks/admin/retry';

/**
 * Both staff groups.
 *
 * Superuser-gated server-side, so this is only mounted behind
 * `RequireStaffTier tier="superuser"`: for a tenant_creator it would be a
 * settled `403` that `retryControlApi` rightly does not retry.
 */
export function useStaffMembers(): UseQueryResult<StaffMembers, Error> {
  return useQuery<StaffMembers, Error>({
    queryKey: adminQueryKeys.staffMembers(),
    queryFn: ({ signal }) => controlStaffService.listMembers(signal),
    retry: retryControlApi,
  });
}
